<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="validateForm()" class="btn fixed_btn">Save</button>
      <div class="card">
        <p class="title">Open a Ticket</p>
        <div class="inputs">
          <div class="input full">
            <label>Your Message</label>
            <textarea v-model="ticket.message" />
          </div>
          <div class="input full">
            <label>Images</label>
            <div class="images">
              <input
                ref="upload"
                type="file"
                accept="image"
                multiple
                class="hide_upload"
                @change="uploadImages"
              />
              <div class='image-adder'>
                <div v-if='!loader' class="add-image" @click="$refs.upload.click()">
                  <img src="@/assets/img/add.svg" />
                </div>
                <img v-if='loader' class='loader' src="@/assets/img/loader.gif" />
              </div>
              <div :key="i" v-for="(image, i) in ticket.images" class="image">
                <img :src='image'></img>
                <div class="remove-image" @click="removeImage(i)">x</div>
              </div>
            </div>
          </div>
          <div class="btns left">
            <button @click="validateForm()" class="btn round-btn">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";
import Switches from "vue-switches";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const storage = fb.default.storage;
const functions = fb.default.functions;
const auth = fb.default.auth;

export default {
  name: "Support",
  components: {
    Switches
  },
  data() {
    return {
      ticket: {
        message: null,
        images: [],
      },
      loader: false,
      sendEmail: functions.httpsCallable("sendEmail"),
    };
  },
  created() {},
  methods: {
    validateForm() {
      if (this.ticket.message) {
        this.saveTicket();
        this.sendTicket();
      }else {
        Swal.fire("Please enter a message!");
      }
    },
    saveTicket() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false
      });
      let user_data = {
        user_id: this.user_doc.id,
        email: this.user_doc.email,
        phone: this.user_doc.phone,
        name: this.user_doc.name,
        created_at: Date.now()
      }
      let data = Object.assign(this.ticket, user_data);
      db.collection("support_ticket")
        .doc()
        .set(data, { merge: true })
        .then(() => {
          loader.hide();
          Swal.fire("Ticket Sent!", "We'll review and get back to you");
        })
        .catch(err => {
          Swal.fire("Error, try again");
        });
    },
    async sendTicket() {
      return await Promise.all([
        this.sendEmail({
          template_name: "covidpad-support-ticket",
          from_email: null,
          to_email: [
            {
              email: 'marlon@popshap.com',
              type: "to",
            },
            {
              email: 'sean@popshap.com',
              type: "to",
            }
          ],
          handlebars: true,
          global_merge_vars: [
            {
              name: "message",
              content: this.ticket.message,
            },
            {
              name: "images",
              content: this.ticket.images.length ? this.ticket.images[0] : '',
            },
            {
              name: "name",
              content: this.user_doc.name,
            },
            {
              name: "email",
              content: this.user_doc.email,
            },
            {
              name: "phone",
              content: this.user_doc.phone,
            },
          ],
          message: null,
        })
      ]);
    },
    uploadImages(e) {
      this.loader = true;
      let vm = this;
      let images = e.target.files;
      if (images.length) {

        Array.from(images).forEach(image => {
          let imageName = image.name;
          let type = image.type;
          let reader = new FileReader();
  
          reader.readAsDataURL(image);
          reader.onload = e => {
            let storageRef = storage.ref(`support_images/${imageName}}`);
            let uploadTask = storageRef.put(image);
            let blob = e.target.result;
  
            uploadTask.on(
              "state_changed",
              snapshot => {},
              error => {
                vm.logoLoad = false;
                Swal.fire("could not upload image, please try again.");
              },
              snapshot => {
                this.loader = false;
                uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                  this.ticket.images.push(downloadURL );
                });
              }
            );
          };
        });
      }else {
        this.loader = false;
      }
    },
    removeImage(i) {
      this.ticket.images.splice(i, 1);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.edit_init) {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
};
</script>

<style scoped lang="scss">
.totals {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
  p {
    margin-left: 40px;
    font-size: 15px;
    span {
      font-size: 35px;
      font-weight: bold;
      font-family: "SFProDisplay", sans-serif;
      display: block;
    }
  }
}
h3 {
  margin-top: 30px;
}

.text_btn {
  text-decoration: underline;
}

.input-btn {
  display: flex;
  align-items: center;
  input {
    width: 100%;
  }
  .btn {
    flex: none;
    padding-top: 0;
  }
}

.add-answer {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 2px solid #eaeaea;
}

.answers {
  input {
    margin-bottom: 6px !important;
    padding: 5px 15px !important;
    font-size: 15px !important;
  }
}

.add-question {
  margin-top: 30px;
}

h4 {
  margin-top: 0;
  font-weight: 500;
  span {
    display: block;
    font-size: 25px;
    margin-top: 5px;
    font-weight: bold;
  }
}

.question {
  padding: 15px 30px !important;
  position: relative;
  ul {
    margin-bottom: 0;
  }
  .controls {
    display: flex;
    position: absolute;
    right: 20px;
    top: 20px;
    align-items: center;
    img {
      height: 30px;
      margin-left: 20px;
      cursor: pointer;
    }
  }
}

.full .v-select {
  margin-bottom: 15px;
}

.input-data {
  background-color: #eaeaea;
  font-size: 17px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 15px;
  input {
    width: 100%;
    background: transparent;
    margin-bottom: 0;
  }
  .email {
    padding: 5px 10px;
    background-color: white;
    border-radius: 10px;
    margin: 10px 15px;
    margin-bottom: 0;
    margin-right: 0;
  }
}

.input-email-holder {
  display: flex;
  align-items: flex-start;
  width: 100%;
  flex-direction: column;
  .btn {
    padding: 5px 10px;
    width: auto;
    font-size: 13px !important;
    width: auto;
    margin: 10px;
    margin-top: 0;
  }
}

.color-input {
  display: flex;
  position: relative;
  align-items: center;
  input {
    padding-left: 30px;
  }
  span {
    position: absolute;
    left: 15px;
    margin-top: -7px;
  }
  .company-color {
    height: 25px;
    width: 25px;
    margin-left: 10px;
    position: absolute;
    right: 10px;
    margin-top: -7px;
    z-index: 2;
  }
}

.images {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .image-adder {
    width: 100%;
  }
  .add-image,
  .image {
    cursor: pointer;
    background: #eaeaea;
    padding: 20px;
    display: flex;
    font-size: 15px;
    margin-right: 10px;
    margin-bottom: 10px;
    align-items: center;
    width: 120px;
    justify-content: center;
  }
  .add-image {
    img {
      height: 30px;
      cursor: pointer;
    }
  }
  .image {
    width: auto;
    display: flex;
    flex-direction: column;
    .remove-image {
      height: 30px;
      width: 30px;
      font-size: 18px;
      background: white;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      margin-top: 10px;
      color: #f44336;
    }
    img {
      height: 150px;
    }
  }
}

.hide_upload {
  position: absolute;
  z-index: -2;
  width: 0 !important;
}

.type {
  font-weight: normal;
  margin-left: 5px;
}

.loader {
  height: 80px;
}
</style>
